(function(){
  function init(){
    var els=document.querySelectorAll('.gb-reveal:not(.gb-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('gb-in')});}
    else{
      var o=new IntersectionObserver(function(n){n.forEach(function(t){if(t.isIntersecting){t.target.classList.add('gb-in');o.unobserve(t.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
      els.forEach(function(e){o.observe(e);});
    }
    document.querySelectorAll('[data-gb-slider]').forEach(function(s){
      if(s.dataset.gbReady)return;s.dataset.gbReady='1';
      var tr=s.querySelector('[data-gb-track]');if(!tr)return;
      function step(){var c=tr.firstElementChild;return c?c.offsetWidth+18:280;}
      var p=s.querySelector('[data-gb-prev]'),nx=s.querySelector('[data-gb-next]');
      if(p)p.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'});});
      if(nx)nx.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'});});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
  setTimeout(function(){document.querySelectorAll('.gb-reveal').forEach(function(e){e.classList.add('gb-in');});},4000);
})();
